
const prefix = 'learn.dropbox.com/personalization';

export const LOADING_PERSONALIZATION = `${prefix}/LOADING_PERSONALIZATION`;
export const LOADED_PERSONALIZATION = `${prefix}/LOADED_PERSONALIZATION`;
export const PERSONALIZATION_ERROR = `${prefix}/PERSONALIZATION_ERROR`;
